import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { SHOPS_NORMALIZER } from '@core/utils';
import { API_ENDPOINTS, Pos, ShopsPayload } from '@shop/const';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OccShopService {
  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected converter: ConverterService,
  ) {}

  loadShopList(cartId: string): Observable<Pos[]> {
    const url = this.occEndpointsService.buildUrl(API_ENDPOINTS.shopList, {
      urlParams: { cartId },
      queryParams: { fields: 'FULL' },
    });

    return this.http
      .get<ShopsPayload>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, API_ENDPOINTS.shopList),
      })
      .pipe(
        this.converter.pipeable(SHOPS_NORMALIZER),
        map((data) => data.pointOfServices),
      );
  }
}
